var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('div',{class:_vm.bgColor == '1' ? 'insiderBoxOther' : 'insiderBoxOther'},[_c('div',{staticClass:"nameBox"},[_vm._v(_vm._s(_vm.iName))]),(_vm.isShow)?_c('img',{attrs:{"src":require("@/assets/images/delP.png"),"alt":""},on:{"click":_vm.del}}):_vm._e()]),(_vm.repeat)?_c('div',{staticClass:"repeat-bg"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }